module.exports = __webpack_public_path__ + "img/one_optimization.07a1dafc.png";